import React from 'react'

interface CloseIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const CloseIcon: React.FC<CloseIconProps> = ({
  color = '#000',
  gradient = false,
  width = 24,
  height = 24,
  alt = 'Close icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillOpacity='0.87'
        fillRule='evenodd'
        d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default CloseIcon
